import React from "react";
import Routes from "./Routes";
import PerformanceMonitor from "./components/PerformanceMonitor";

function App() {
  return (
    <>
      <Routes />
      <PerformanceMonitor />
    </>
  );
}

export default App;
